import React from "react";
import { Card, CardBody, CardTitle, Col, Container, Row } from "react-bootstrap";
import { IBlogDetailsCubit } from "../blocs/blog/BlogDetailsBloc";
import { BlogState } from "../blocs/blog/blogStates";
import useCubit from "../blocs/hooks";
import BlogViewer from "./BlogViewer";
import CommentForm from "./CommentForm";
import CommentTile from "./CommentTile";
import NotFound from "./NotFound";
import SearchElementTile from "./SearchElementTile";

interface BlogDetailsBodyProps {
    cubit: IBlogDetailsCubit;
}


const BlogDetailsBody: React.FC<BlogDetailsBodyProps> = ({ cubit }) => {
    const blogDetailsState = useCubit<BlogState>(cubit);
    return <Container style={{ marginTop: 85, marginBottom: 85 }} >
        {
            (!['ERROR', 'LOADING', 'NOT_FOUND'].includes(blogDetailsState.state)) && (<Row>
                <Col xs={window.innerWidth > 991 ? 9 : 12}>
                    <BlogViewer blog={blogDetailsState.blog!} />
                </Col>
                <Col>
                    <Card style={{
                        padding: 16,
                        marginTop: window.innerWidth > 991 ? 0 : 8,
                    }}>
                        <CardTitle>Comments</CardTitle>
                        <CardBody style={{ padding: 0 }}>
                            <CommentForm cubit={cubit} />
                            {blogDetailsState.state === 'ADDING_COMMENT'
                                && <CommentTile comment={blogDetailsState.addedComment!} key='NewComment' visible={false} />
                            }
                            {blogDetailsState.blog!.comments!.map(
                                (comment) => <CommentTile
                                    comment={comment}
                                    key={comment.id}
                                    visible
                                />)}
                        </CardBody>
                    </Card>
                    {
                        blogDetailsState.blog?.similarArticles && <Card style={{
                            padding: 16,
                            marginTop: 8,
                        }}>
                            <CardTitle>Related articles</CardTitle>
                            <CardBody style={{ padding: 0 }}>
                                {
                                    blogDetailsState.blog!.similarArticles!.map((target, index) => <div style={{
                                        borderWidth: 1,
                                        borderColor: "#d2d2d2",
                                        borderStyle: "solid",
                                        margin: 2,
                                        padding: 2,
                                        marginBottom: 8,
                                        borderRadius: 4,
                                    }}>
                                        <SearchElementTile target={target} key={index} />
                                    </div>)
                                }
                            </CardBody>
                        </Card>
                    }
                </Col>
            </Row>)
        }
        {(blogDetailsState.state === 'NOT_FOUND') && <NotFound />}

    </Container>;
}

export { BlogDetailsBody };
